/**
 * created by wang lei
   查看栏目树 页面
 *
 */
import React from 'react';
import BaseComponent from "../../../base/BaseComponent";
import {Scrollbars} from "react-custom-scrollbars";
import {Tree,Modal,Button} from "antd";

const { TreeNode } = Tree;

const getExamineNodesUrl = '/cm-sites-pms/website/getColumnTreeByMediaId';

export default class ExamineTree extends BaseComponent {
    static defaultProps = {};
    static propTypes = {};

    constructor(props) {
        super(props);
        this.state = {
            visible: false,
            treeData: [],
        }
    }

    componentWillUnmount() {
    }
    
    componentDidMount() {
    }

    showModal = (record) => {
        this.getTree(record?.id);
        this.setState({
            visible: true,
        });
    };

    handleOk = e => {
        this.handleCancel();
    };

    handleCancel = e => {
        if (typeof this.props.onCloseCall === 'function') {
            this.props.onCloseCall();
        }
        this.setState({
            visible: false,
        });
    };


    /**
     * 树形数据节点展示
     * @param {*} nodeData  节点数据
     */
    treeNodeRender = nodeData => {
        return (
            <>
                {
                    nodeData.map(item=>(
                        <TreeNode title={item.title} key={item.key}>
                            { item.subtree && Array.isArray(item.subtree) ? this.treeNodeRender(item.subtree) : null}
                        </TreeNode>
                    ))
                }
            </>
        )
    }

    modalFooterRender = () => [
        <Button key='close' onClick={this.handleCancel}>关闭</Button>
    ]

    render() {
        const { visible, treeData } = this.state;

        return (
            <Modal
                title="栏目信息"
                visible={visible}
                onOk={this.handleOk}
                onCancel={this.handleCancel}
                destroyOnClose
                width={500}
                bodyStyle={{height: 300}}
                footer={this.modalFooterRender()}
            >
                <Scrollbars  autoHide autoHeightMax={252}>
                    {
                        treeData?.length ? (
                            <Tree 
                        selectable={false} 
                        defaultExpandAll
                    >
                        {this.treeNodeRender(treeData)}
                    </Tree>
                        ) : ""
                    }
                </Scrollbars>
            </Modal>
        )
    }

    /**
     * 获取栏目树数据
     */
    getTree = (mediaId) => {
        this.request({
            url: getExamineNodesUrl,
            body: { mediaId },
            callBack: (res) => {
                let tempTreeData = [];
                if (res) {
                    tempTreeData.push(res);
                }
                this.setState({
                    treeData: tempTreeData,
                });
            },
        });
    }
}